module.exports = __webpack_public_path__ + "img/gift.f7367c4d.png";